import { ClientApiPostRequest } from 'types/client'
import { getApiRequest, postApiRequest, putApiRequest } from 'utils/fetch-helper'

export async function createClient(
    input: ClientApiPostRequest & { notes?: string }
) {
    const client = await postApiRequest('/v1/clients', input)
    return client
}

export async function findOrCreateClient(
    input: ClientApiPostRequest & { notes?: string }
) {
    let client = await searchClientByEmail(
        input.user.email,
        input.tenant.id
    )
    if (client.id) return client

    client = await postApiRequest('/v1/clients', input)
    if (client.error) throw Error(client.error)
    return client
}

export async function createOrUpdate(
    input: ClientApiPostRequest & { notes?: string }
) {

    let client = await searchClientByEmail(
        input.user.email,
        input.tenant.id
    )
    
    if (!client?.id) {
        client = await postApiRequest('/v1/clients', input)
    }
    else if (client?.id && !client?.cognitoId) {
        client.cognitoId = input.cognitoId
        client = await putApiRequest(`/v1/clients/${client.id}`, client)
    }
    
    if (client.error) throw Error(client.error)

    return client
}

export async function createOrLinkUser(input: ClientApiPostRequest) {
    const client = await postApiRequest('/v1/clients/create-or-link-user', input)
    
    if (client.error) throw Error(client.error)

    return client
}

export async function searchClientByEmail(
    email: string,
    tenant_id: string
) {
    return await getApiRequest(
        `/v1/clients/by-tenant-id-and-email?tenantId=${tenant_id}&email=${encodeURIComponent(
            email
        )}`
    )
}
